export const WHATSAPP_LINK =
  "https://wa.me/918657696796?text=Hi%20PLACE8,%20I%20would%20like%20to%20discuss%20our%20recruitment%20and%20hiring%20requirements.";

export const LOGO_URL = "/place8_logo.png";

export const IMAGES = {
  hero: "https://images.openai.com/static-rsc-4/9rZhJcCtqQLahVcvyL1d6vh-81y3pNpwOAWGQE346NPl1nf50u8pZ5CMJaAJm3tFDj4t_I1b0LgviqoAW3-gId_ZtrpJQ4L_061h0rcXqYaHwggj6j2OKtw75UGhoqB42orRDkAPWehjy5FthiKy5_F_458_yHUfG_FQDcHzW_IeBmALEpGwqBQnwKJ0bA-Z?purpose=fullsize",
  about: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  meeting: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  executive: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  tech: "https://images.unsplash.com/photo-1531482615713-2afd69097998?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Why PLACE8", href: "#why" },
  { label: "Impact", href: "#impact" },
  { label: "Clients", href: "#clients" },
  { label: "Contact", href: "#contact" },
];

export const HERO_CONTENT = {
  badge: "Premium Recruitment Consultancy",
  heading: "Premium Recruitment Solutions",
  subheading:
    "Helping businesses hire exceptional talent through executive search, permanent hiring, bulk recruitment, staffing solutions, and industry-specific hiring across India.",
  primaryCta: "Hire Talent",
  secondaryCta: "Book Consultation",
};

export const RECRUITMENT_SERVICES = [
  {
    icon: "FaUserTie",
    title: "Executive Search",
    desc: "Leadership and senior management hiring tailored for defining roles.",
    details: ["C-Suite & Board Hiring", "Vice President & Director Roles", "Confidential Talent Search", "Leadership Assessment"],
  },
  {
    icon: "FaBriefcase",
    title: "Permanent Hiring",
    desc: "Complete recruitment solutions for full-time positions aligned with your company vision.",
    details: ["End-to-End Recruitment", "Culture-Fit Sourcing", "Role Architecture", "Guaranteed Retention"],
  },
  {
    icon: "FaUsers",
    title: "Bulk Hiring",
    desc: "Mass recruitment drives for growing businesses scaling up operations rapidly.",
    details: ["Volume Recruitment", "Campus & Off-Campus Drives", "Rapid Onboarding", "Structured Pipeline"],
  },
  {
    icon: "FaLaptopCode",
    title: "IT Recruitment",
    desc: "Hiring software developers, engineers, analysts, QA, cloud, DevOps, cybersecurity, AI & data science experts.",
    details: ["Full-Stack Developers", "Cloud & DevOps Engineers", "AI & Data Science Talent", "Cybersecurity Specialists"],
  },
  {
    icon: "FaBuildingUser",
    title: "Non-IT Recruitment",
    desc: "Talent acquisition for Sales, HR, Finance, Banking, Operations, Marketing, Manufacturing & Administration.",
    details: ["Sales & Business Development", "Finance & Accounts Leadership", "Operations & Supply Chain", "HR & Admin Staffing"],
  },
  {
    icon: "FaStethoscope",
    title: "Healthcare Recruitment",
    desc: "Specialized staffing for Doctors, Nurses, Pharmacists, Clinical Researchers and Healthcare Executives.",
    details: ["Specialist Physicians & Doctors", "Nursing & Paramedical Staff", "Hospital Administration", "Pharma & Biotech Hiring"],
  },
  {
    icon: "FaLandmark",
    title: "BFSI Recruitment",
    desc: "Banking, Insurance, NBFCs, Investment Management and Financial Services talent acquisition.",
    details: ["Investment Banking", "Retail & Commercial Banking", "Wealth & Risk Management", "Fintech & Insurance Pros"],
  },
  {
    icon: "FaHandshakeSimple",
    title: "Recruitment Process Outsourcing (RPO)",
    desc: "Dedicated recruitment teams managing complete or modular hiring functions for organizations.",
    details: ["On-Site / Virtual Sourcing Teams", "Recruitment Lifecycle Management", "Employer Branding Support", "Cost-Effective Scalability"],
  },
];

export const INDUSTRIES_WE_SERVE = [
  {
    icon: "FaLaptopCode",
    title: "Information Technology",
    desc: "Software Development, Cloud, DevOps, AI/ML, Cybersecurity & Tech Leadership.",
  },
  {
    icon: "FaLandmark",
    title: "Banking",
    desc: "Retail Banking, Commercial Banking, Treasury, Risk & Corporate Governance.",
  },
  {
    icon: "FaCoins",
    title: "Financial Services",
    desc: "NBFCs, Wealth Management, Broking, Capital Markets & Insurance.",
  },
  {
    icon: "FaStethoscope",
    title: "Healthcare",
    desc: "Hospitals, Clinics, Pharmaceuticals, Medical Devices & Clinical Research.",
  },
  {
    icon: "FaIndustry",
    title: "Manufacturing",
    desc: "Automotive, Chemicals, Engineering, Industrial Equipment & Production.",
  },
  {
    icon: "FaStore",
    title: "Retail",
    desc: "FMCG, Luxury Retail, Consumer Goods, Franchise Operations & Merchandising.",
  },
  {
    icon: "FaHotel",
    title: "Hospitality",
    desc: "Hotels, Resorts, Food & Beverage Chains, Travel & Event Management.",
  },
  {
    icon: "FaTruckRampBox",
    title: "Logistics",
    desc: "Supply Chain, Warehousing, Freight Forwarding, Fleet & Port Operations.",
  },
  {
    icon: "FaSignal",
    title: "Telecom",
    desc: "Network Engineering, Wireless Communication, Fiber Infrastructure & Sales.",
  },
  {
    icon: "FaCartShopping",
    title: "E-Commerce",
    desc: "Digital Marketing, Product Management, Logistics Tech & Marketplace Ops.",
  },
  {
    icon: "FaHeadset",
    title: "BPO/KPO",
    desc: "Customer Support, Voice & Non-Voice Operations, Analytics & Tech Support.",
  },
  {
    icon: "FaRocket",
    title: "Startups",
    desc: "Early-stage to Series-C talent hiring, founding engineers, product managers & growth heads.",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "FaAward",
    title: "Industry Expertise",
    desc: "Deep domain knowledge across IT, Non-IT, BFSI, Healthcare, and Corporate functions.",
  },
  {
    icon: "FaGlobe",
    title: "PAN India Hiring",
    desc: "Seamless candidate sourcing across metros and Tier-1/Tier-2 cities nationwide.",
  },
  {
    icon: "FaUserTie",
    title: "Dedicated Recruitment Specialists",
    desc: "Domain-focused account managers assigned to understand your unique hiring needs.",
  },
  {
    icon: "FaBolt",
    title: "Fast Turnaround Time",
    desc: "Rapid candidate pipeline delivery and interview coordination to close positions quickly.",
  },
  {
    icon: "FaUserCheck",
    title: "Quality Candidate Screening",
    desc: "Comprehensive multi-stage vetting, technical assessment, and cultural fit verification.",
  },
  {
    icon: "FaLightbulb",
    title: "Customized Hiring Strategy",
    desc: "Bespoke sourcing channels and recruitment workflows designed around your business goals.",
  },
  {
    icon: "FaHeart",
    title: "Long-Term Client Partnerships",
    desc: "High client retention driven by high candidate performance and transparent SLAs.",
  },
  {
    icon: "FaShieldHalved",
    title: "Transparent Recruitment Process",
    desc: "Real-time updates, clear candidate tracking, and honest communication at every step.",
  },
];

export const STATS = [
  { value: 5000, suffix: "+", label: "Candidates Placed", icon: "FaUserCheck" },
  { value: 55, suffix: "+", label: "Hiring Partners", icon: "FaBuildingColumns" },
  { value: 95, suffix: "%", label: "Client Satisfaction", icon: "FaHeart" },
  { value: 15, suffix: "+", label: "Industries Served", icon: "FaLayerGroup" },
];

export const CLIENTS = [
  { name: "Shaadi.com", logo: "https://s3.amazonaws.com/wp.shaadi.com/blog.shaadi.com/prod/uploads/2015/09/New-Shaadi-Logo2.jpg", category: "E-Commerce & Tech", highlight: "Tech & Leadership Staffing" },
  { name: "Hexaware", logo: "https://mma.prnewswire.com/media/530945/Hexaware_Rebranding_Logo.jpg?p=facebook", category: "IT & Digital Services", highlight: "Software & Cloud Hiring" },
  { name: "HDB Financial", logo: "https://media.licdn.com/dms/image/v2/D5612AQGjK_B85JeEwQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1705564084260?e=2147483647&v=beta&t=ZO7X9v2pztj2iw1tRL_5ilvHlCMq6iI7IhbNVX-yvlA", category: "BFSI & Banking", highlight: "Volume & Sales Hiring" },
  { name: "EOS Globe", logo: "https://media.licdn.com/dms/image/v2/C560BAQE8MZSVmpHrng/company-logo_200_200/company-logo_200_200/0/1655307800039/eureka_outsourcing_solutions_pvt_ltd_logo?e=2147483647&v=beta&t=cHYLMPbpeyg6SOFggbUmLO3I2JeS0l3djwoIBU0eijQ", logoClass: "scale-125 max-h-[115px]", category: "BPO & KPO", highlight: "Operations & Customer Care" },
  { name: "Cogent", logo: "https://storage.googleapis.com/5paisa-prod-storage/files/2023-10/Cogent%20E-Services.png", logoClass: "scale-[1.65] max-h-[140px]", category: "Customer Experience & IT", highlight: "Bulk & Specialized Recruitment" },
  { name: "Altruis", logo: "https://media.licdn.com/dms/image/v2/D4E0BAQG-nKUU7srVMw/company-logo_200_200/B4EZd5PBOaGwAQ-/0/1750085670333/1point1_logo?e=2147483647&v=beta&t=Z_yrvxcM_LlpeVWVaieqBaCgQHU1nCEVGetcEfkzcbs", logoClass: "scale-135 max-h-[120px]", category: "Healthcare & Tech Services", highlight: "Specialized Staffing" },
  { name: "BDS Services", logo: "https://media.licdn.com/dms/image/v2/C510BAQG-zn5CbvJ3Ow/company-logo_200_200/company-logo_200_200/0/1630624759777/bdsservices_logo?e=2147483647&v=beta&t=pm1sK1SEs9jmuIv3OzYBaYIOvgrGgo2111A3FUyOKTo", logoClass: "scale-[1.65] max-h-[140px]", category: "Enterprise & Growth Startups", highlight: "Custom Hiring Solutions" },
  { name: "Epicenter Technologies", logo: "https://media.designrush.com/agencies/292060/conversions/Epicenter-Technologies-Pvt-Ltd-logo-profile-webp.webp", logoClass: "scale-125 max-h-[115px]", category: "BPO & IT Services", highlight: "Operations & CX Staffing" },
  { name: "Enterprise Partner", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaLBKahUVhRN46rttLRPwMKJJtFvmWOsBxuXqonIKo0vs3EpBk_M_kceo&s=10", logoClass: "scale-[1.65] max-h-[135px]", category: "Enterprise & Tech", highlight: "Specialized Sourcing" },
  { name: "Enterprise Partner", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMWDZotXb4QM-YVpQ1wnVUScNRL8WXATNTXQ-6VJOACjDG6aEZSE2IeqoS&s=10", logoClass: "scale-[1.65] max-h-[135px]", category: "Enterprise & Tech", highlight: "Specialized Staffing" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Strategic Talent Sourcing.",
    body: "We go beyond resume matching. PLACE8 identifies passive and active talent through targeted industry mapping, expert evaluation, and rigorous candidate screening.",
  },
  {
    no: "02",
    title: "Speed Without Compromise.",
    body: "Our specialized recruiters streamline your hiring timeline with pre-vetted candidate pools, ensuring high offer acceptance rates and minimal time-to-fill.",
  },
  {
    no: "03",
    title: "Partnerships Built on Performance.",
    body: "We measure success by long-term employee retention and measurable client impact. From startups to multi-national enterprises, PLACE8 scales with your vision.",
  },
];

export const FOOTER_COPY = {
  tagline: "Connecting Exceptional Talent with Exceptional Companies",
  description:
    "PLACE8 Talent is a premium Recruitment Agency in Navi Mumbai offering Executive Search, Staffing Solutions, IT Recruitment, Non-IT Recruitment, Permanent Hiring, and Talent Acquisition services across India.",
};

export const CONTACT = {
  phones: ["+91 8657696796", "+91 9152093759"],
  emails: {
    jobseekers: ["Hr@place8.in"],
    business: ["Business@place8.in", "Rohitt@place8.in"],
  },
  office: {
    name: "PLACE8 Talent",
    address:
      "6th Floor, Juinagar, Ellora Fiesta, Plot No.8, West, Sector 11, Sanpada, Navi Mumbai, Maharashtra 400705, India",
    lines: [
      "6th Floor, Juinagar, Ellora Fiesta, Plot No.8, West",
      "Sector 11, Sanpada, Navi Mumbai",
      "Maharashtra 400705, India",
    ],
    googleBusinessProfile: "https://share.google/YyxCsJhcjFOP2iDLS",
    mapSrc:
      "https://www.google.com/maps?q=6th+Floor,+Juinagar,+Ellora+Fiesta,+Plot+No.8,+West,+Sector+11,+Sanpada,+Navi+Mumbai,+Maharashtra+400705,+India&output=embed",
  },
  linkedin: "https://www.linkedin.com/company/place8talent/",
  instagram: "https://www.instagram.com/place8talent/",
};
